// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JBBzO","active":"Button_active__iTrrO","disabled":"Button_disabled__DkgJ+"};